<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <header-add @openModal="openModal" v-if="isCreate()" />
        </div>
        <div v-if="isIndex()">
          <card-header
            @searchedQuery="searchedQuery"
            class="mr-3 mt-4"
          ></card-header>

          <master-table
            :infoTable="queriedData"
            :columns="tableColumns"
            :showColumnStatus="true"
          >
            <template slot="addColumns">
              <table-column-badges
                prop="businesses[0].name"
                :label="$t('common_words.associated_companies2')"
                fromData="businesses"
                textBadge="name"
              />
            </template>
            <template slot="addColumnsOperations">
              <table-columns-operations
                v-if="isShow() || isUpdate() || isDelete()"
                @handleView="handleView"
                @handleEdit="handleEdit"
                @handleDelete="handleDelete"
                @handleActivate="handleActivate"
                :canDisable="true"
              />
            </template>
          </master-table>
        </div>
        <not-index-permissions v-else />
        <card-footer ref="cardfooter" />
        <export-tables
          :pdf="{
            filename: `${$t('labor.activities_unit')}.pdf`,
            route: 'works/activityunits/pdf',
          }"
          :xls="{
            filename: `${$t('labor.activities_unit')}.xslx`,
            route: 'works/activityunits/excel',
          }"
        />
        <br />
      </card>
      <el-dialog
        width="50%"
        :title="getTitleDialog"
        :visible.sync="modals.create"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <form>
          <div class="row">
            <div class="col-md-7 col-lg-7 col-xl-5">
              <fg-input
                type="text"
                :label="`${$t('common_words.name')} *`"
                v-model="model.name"
                name="common_words.name"
                v-validate="modelValidations.name"
                :error="getError('common_words.name', true)"
                placeholder=" ..."
              >
              </fg-input>
            </div>
            <div class="col-md-5 col-lg-5 col-xl-2">
              <fg-input
                type="text"
                :label="`${$t('common_words.symbol')} *`"
                v-model="model.abbreviation"
                name="common_words.symbol"
                v-validate="modelValidations.abbreviation"
                :error="getError('common_words.symbol', true)"
                placeholder="..."
              >
              </fg-input>
            </div>
            <div
              :class="`${
                businesses.length > 2
                  ? `col-md-5 col-lg-12 col-xl-5`
                  : `col-md-12 col-xl-5`
              }`"
            >
              <div class="form-group has-label">
                <label for="">{{ $t('labor.unit_format') }}: *</label>
                <br />
                <el-select
                  filterable
                  class="select-primary mb-3 shadow-sm required-hour_type"
                  v-model="model.data_formate"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in dataFormate"
                    :key="item.id + item.value"
                    :label="item.value"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div v-if="businesses.length > 2" class="col-md-7 col-lg-12">
              <div class="form-group has-label">
                <label>{{ $t('common_words.companies2') }}: *</label>
                <br />
                <el-select
                  collapse-tags
                  @change="selectAllFromSelect('model.business_id', businesses)"
                  clearable
                  multiple
                  filterable
                  class="select-primary custom-width-select shadow-sm required-business"
                  size="large"
                  v-model="model.business_id"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in businesses"
                    class="select-primary selected-all"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </form>
        <hr class="mb-0" />
        <dialog-button-form
          slot="footer"
          @closeModal="closeModal"
          @validate="validate"
        />
      </el-dialog>
      <el-dialog
        top="2%"
        v-if="isShow()"
        :title="$t('common_words.record_selected_threepoints')"
        :visible.sync="modals.read"
        width="60%"
      >
        <div class="card" v-if="rowData">
          <div class="card-body" v-if="rowData">
            <table class="table">
              <tbody>
                <tr class="shadow-sm">
                  <td>
                    <h6 class="mb-2">
                      <strong>{{ $t('common_words.name') }}:</strong>
                    </h6>
                    {{ rowData.name }}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td>
                    <h6 class="mb-2">
                      <strong>{{ $t('common_words.symbol') }}:</strong>
                    </h6>
                    {{ rowData.abbreviation }}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td>
                    <h6 class="mb-2">
                      <strong>{{ $t('labor.unit_format') }}:</strong>
                    </h6>
                    {{ rowData.data_formate }}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td>
                    <h6 class="mb-2">
                      <strong>{{ $t('common_words.companies2') }}:</strong>
                    </h6>
                    <span v-for="(b, index) in rowData.businesses" :key="index">
                      <el-tag type="info">{{ b.name }}</el-tag>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer footer-date-at" v-if="rowData">
            <p class="text-muted">
              <small
                >{{ $t('common_words.created_on') }}:
                {{ rowData.created_at }}</small
              >
            </p>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Fuse from 'fuse.js';
import { Axios } from 'src/class/Axios.js';
import { Pagination as LPagination } from 'src/components/index';
import ButtonForm from 'src/components/Dialogs/Forms/ButtonForm';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';
import configTable from './activity-units-table';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  components: {
    [ButtonForm.name]: ButtonForm,
    LPagination,
  },
  computed: {
    ...configTable().Search,
    getTitleDialog() {
      return this.model.route
        ? i18n.t('labor.unit_selected_edit')
        : i18n.t('labor.unit_add_new');
    },
  },
  data() {
    return {
      model: {
        name: null,
        abbreviation: null,
        data_formate: null,
        business_id: [],
        route: null,
      },
      modelValidations: {
        name: {
          required: true,
        },
        abbreviation: {
          required: true,
        },
      },
      dataFormate: [
        { id: 'entero', value: 'Entero' },
        { id: 'decimal', value: 'Decimal' },
      ],
      Table: {},
      Search: {},
      pagination: {},
      tableColumns: [],
      businesses: [],
    };
  },

  mixins: [MixinMasters, MixinPermissions, MixinForm, MixinMenu],

  watch: {
    '$i18n.locale': ['setupTable', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },
    openModal(name) {
      if (name == 'create') {
        this.title = i18n.t('labor.unit_add_activity');
        this.$validator.reset();
        this.model.name = null;
        this.model.abbreviation = null;
        this.model.business_id = this.selectElementsAsignFromModel(
          1,
          this.model.business_id,
          this.businesses
        );
        this.model.route = null;
      }
      this.modals[name] = true;
    },

    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (this.model.business_id.length === 0) {
            return this.validationInputsRequired('business');
          } else if (!this.model.data_formate) {
            return this.validationInputsRequired('hour_type');
          } else {
            this.addActivityUnit();
          }
        }
      });
    },

    handleView(index, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      this.title = i18n.t('labor.unit_edit_activity') + row.name;
      this.model.id = row.id;
      this.model.name = row.name;
      this.model.abbreviation = row.abbreviation;
      this.model.data_formate = row.data_formate;
      this.$set(
        this.model,
        'business_id',
        row.businesses.map((business) => business.id)
      );
      this.errors.clear();
      this.model.route = 'works/activityunits';
      this.modals['create'] = true;
    },

    handleDelete(index, row) {
      this.model = row;
      SweetAlert.disable(`${i18n.t('labor.unit')} "${this.model.name}"`).then(
        (result) => {
          if (result.value) this.deleteActivityUnit();
        }
      );
    },

    handleActivate(index, row) {
      this.model = row;
      SweetAlert.default(
        `${i18n.t('labor.unit_part_text')}"${this.model.name}"?`,
        null,
        i18n.t('common_words.accept'),
        1
      ).then((result) => {
        if (result.value) this.activateActivityUnit();
      });
    },

    activateActivityUnit() {
      if (this.isUpdate()) {
        this.showHideLoading(true);
        this.model.route = 'works/activityunits/activate';
        Axios.updateMaster(this.model)
          .then((response) => this.modifyTable(1, this.model.id, response))
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    addActivityUnit() {
      this.showHideLoading(true);
      if (this.model.route == 'works/activityunits') {
        if (this.isUpdate()) {
          Axios.updateMaster(this.model)
            .then((response) => {
              this.modifyTable(1, this.model.id, response);
              sessionStorage.removeItem('editForm');
            })
            .catch((error) => {
              this.showMessageErrors(error);
            });
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          this.model.route = 'works/activityunits';
          Axios.saveMaster(this.model)
            .then((response) => {
              this.modifyTable(0, null, response);
            })
            .catch((error) => {
              this.showMessageErrors(error);
            });
        }
      }
    },

    deleteActivityUnit() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.model.route = 'works/activityunits';
        Axios.destroyMaster(this.model)
          .then((response) => {
            this.modifyTable(1, this.model.id, response);
          })
          .catch((error) => this.showMessageErrors(error));
      }
    },

    setupTable() {
      const { Table, Search } = configTable();
      // Assign the Table and Search objects to your data properties
      this.Table = Table;
      this.Search = Search;
      this.tableColumns = Table.tableColumns;
      this.pagination = Table.pagination;
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('works/activityunits'),
        Axios.getMasters('businesses/only'),
      ])
        .then((response) => {
          const [response_activityUnit, response_businesses] = response;
          this.tableData = response_activityUnit.data.data;
          this.businesses = this.concatAll(response_businesses.data.data);

          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });
          this.showHideLoading();
        })
        .catch((error) => {
          this.showMessageErrors(error);
        });
    } else {
      this.showHideLoading();
    }
  },
  mounted() {
    this.selectedItemOnMenu('works');
  },

  destroyed() {
    this.deselectedItemOnMenu('works');
  },
};
</script>
